module.exports = __webpack_public_path__ + "static/img/pan_03.7d3c3ee.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/pan_03.png
// module id = +UxJ
// module chunks = 1